//import axios from "axios";
import {
  CONFIRMED_GET_NOTES,
  CONFIRMED_CREATE_NOTE_ACTION,
  CONFIRMED_SEND_DOCTOR_NOTE_REPLY
} from "./NoteTypes.js";
import { getNotes, createNote, formatNotes ,sendDoctorNoteReply} from "../../services/NoteService";
import swal from "sweetalert";
import {
  handleError,
  handleSuccess,
  showErrorAlert,
} from "../../services/ErrorHandlingService.js";

function getAuthToken(getState) {
  const stateToken = getState().auth?.authKey;
  if (stateToken) return stateToken;

  const storedUser = localStorage.getItem("userDetails");
  return storedUser ? JSON.parse(storedUser).token : null;
}
// Action to get notes list
export function getNotesAction(patient_id, pagination = false, pageid = 0) {
  return async (dispatch, getState) => {
    try {
      //const token = getAuthToken(getState);
      //console.log("Parameters:", admin_id, pagination, pageid, token);
      const userDetails = JSON.parse(localStorage.getItem("userDetails"));
      //const admin_id = userDetails?.admin_id || 0;

      const response = await getNotes(patient_id, pagination, pageid);

      if (response && response.status === 200 && response.data) {
        if (response.data.status === "success" && response.data.data) {
          console.log("responseData:", response.data);
          const notes = formatNotes(response.data.data);

          console.log("response", notes);
          dispatch({ type: CONFIRMED_GET_NOTES, payload: notes });
        } else {
          handleError("Failed to get notes: Server error");
        }
      } else {
        handleError("Failed to get notes: Network error");
      }
    } catch (error) {
      console.error("API Error:", error.response || error);
      showErrorAlert("Failed to get notes");
    }
  };
}

//  Action to create a new note
export function createNoteAction(noteData) {
  return async (dispatch) => {
    try {
      const response = await createNote(noteData);

      if (response?.status === 200 && response.data?.status === "success") {
        dispatch({
          type: CONFIRMED_CREATE_NOTE_ACTION,
          payload: response.data.data, // ✅ backend note
        });

        handleSuccess("Note created successfully!");
        return response.data.data;
      } else {
        showErrorAlert("Failed to create note");
        throw new Error("Create note failed");
      }
    } catch (error) {
      console.error("API Error:", error);
      showErrorAlert("Failed to create note");
      throw error;
    }
  };
}


// actions.js or wherever you define your Redux actions
export const sendDoctorNoteReplyAction = (note_id, reply) => {
  return async (dispatch) => {
    try {
      const response = await sendDoctorNoteReply(note_id, reply);
      console.log("Doctor Note Reply API Response:", response);

      dispatch({
        type: CONFIRMED_SEND_DOCTOR_NOTE_REPLY, // Define this in your action types
        payload: response?.data || {},
      });

      return {
        ...response?.data,
        success: true,
      };
    } catch (error) {
      console.error("Error in sendDoctorNoteReplyAction:", error);
      throw error;
    }
  };
};
